import { BlockItem } from '@/models/Blocks/Itens/block-item';

export class BlockEvents{
    public static AddEventsListener(component: any){
        if(component?.$el??null){
            component.$el.addEventListener('actionBoxClick', (e: any|undefined) => {
                if(e instanceof CustomEvent){
                    try{
                        let name: string|undefined  = e?.detail?.type ?? undefined;
                        let value = e?.detail?.value ?? null;
                        name && component.$emit(name, value);
                    }catch(e){}
                }
            });

            component.$el.addEventListener('actionItemClick', (e: any|undefined) => {
                if(e instanceof CustomEvent){
                    let item: any|undefined = e?.detail?.item ?? undefined;
                    if(item && (item instanceof BlockItem)){
                        component.$emit('itemClick', item);
                    }
                }
            });

            component.$el.addEventListener('productItemClick', (e: any|undefined) => {
                if(e instanceof CustomEvent){
                    let item: any|undefined = e?.detail?.item ?? undefined;
                    if(item && (item instanceof BlockItem)){
                        component.$emit('productClick', item);
                    }
                }
            });
        }
    }

    public static AddSocialLikeListener(callBack: Function){
        document.body.addEventListener('actionSocialLike', (e: any|undefined) => {
            if(e instanceof CustomEvent){
                let itemId: string|null = e?.detail?.itemId ?? null;
                let liked: boolean|null = e?.detail?.liked ?? null;
                if(itemId !== null && liked !== null){
                    callBack(itemId,liked);
                }
            }
        });
    }

    public static AddActionBoxClick(elem: Element, action: any|undefined = undefined){
        if (action) {
            let type: string = action?.type ?? null;
            let value: any = action?.value ?? null;
            if (type && type != 'link') {
                let baseElem = elem.closest('.prz-blk');
                if (baseElem && baseElem instanceof HTMLElement) {
                    const event = new CustomEvent('actionBoxClick', {
                        detail: {
                            type: type,
                            value: value
                        }
                    });
                    baseElem.dispatchEvent(event);
                }
            }
        }
    }

    public static AddActionItemClick(elem: Element, detail: any){
        let baseElem = elem.closest('.prz-blk');
        if (baseElem && baseElem instanceof HTMLElement) {
            const event = new CustomEvent('actionItemClick', {
                detail: detail,
                cancelable: true,
                bubbles: true
            });
            baseElem.dispatchEvent(event);
        }
    }

    public static AddProductClick(elem: Element, detail: any){
        let baseElem = elem.closest('.prz-blk');
        if (baseElem && baseElem instanceof HTMLElement) {
            const event = new CustomEvent('productItemClick', {
                detail: detail,
                cancelable: true,
                bubbles: true
            });
            baseElem.dispatchEvent(event);
        }
    }

    public static AddSocialLikeAction(info: any){
        let baseElem = document.body;
        if (baseElem && baseElem instanceof HTMLElement) {
            const event = new CustomEvent('actionSocialLike', {
                detail: info,
                cancelable: true,
                bubbles: true
            });
            baseElem.dispatchEvent(event);
        }
    }
}